import { render } from "./Sidebar.vue?vue&type=template&id=7d8ed4dd&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=7d8ed4dd&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=7d8ed4dd&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8ed4dd"]])

export default __exports__